import { render, staticRenderFns } from "./GalleryFilterLink.vue?vue&type=template&id=3fe4e09a&scoped=true"
import script from "./GalleryFilterLink.vue?vue&type=script&lang=js"
export * from "./GalleryFilterLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe4e09a",
  null
  
)

export default component.exports